import { Link } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function LoggedOut() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <LogOut className="h-12 w-12 text-blue-600 dark:text-blue-500" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
          You've been signed out
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
          Thank you for using AI Prime Consulting
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white dark:bg-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="flex justify-center">
            <Link to="/login">
              <Button>
                Sign in again
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex items-center justify-center">
          <img
            src="/aipc-final.svg"
            alt="Logo"
            className="h-6 dark:invert"
          />
        </div>
      </div>
    </div>
  );
}